import messages from './myCases.json' with { type: 'json' };

export const myCasesFi: Readonly<typeof messages> = messages;
